export default class SelectedGroupHashChangeDispatcher {
  public static EVENT_TYPE: string = 'selectedGroupHashChange';

  public static dispatchEvent() {
    const event = new CustomEvent(this.EVENT_TYPE);
    window.dispatchEvent(event);
  }
}
